import React from 'react';
import moment from 'moment';

import sAction from 'sAction';

function Footer() {
    const company = sAction.param.portalCompany;
    return (
        <div className="pageFooter">
            <div className="loginPageFooterContainer">
                <div className="footerCopyright footerItem">
                    <a href='https://www.aon.com/en/'>{sAction.translate('LBL_PRODUCTS_AND_SERVICES')}</a>
                    <a href='http://ir.aon.com/'>{sAction.translate('LBL_INVESTOR_RELATIONS')}</a>
                    <a href='http://www.aon.com/about-aon/careers.jsp'>{sAction.translate('LBL_CAREERS')}</a>
                    <a href='https://www.aon.com/about-aon/privacy.jsp'>{sAction.translate('LBL_PRIVACY_POLICY')}</a>
                    <a href='http://www.aon.com/about-aon/cookies.jsp'>{sAction.translate('LBL_COOKIE_NOTICE')}</a>
                    <p>© {moment().format('YYYY')} {company === 'aon' ? 'Aon' : 'ERN'}. {sAction.translate('LBL_ALL_RIGHTS_RESERVED')}.</p>
                </div>
                {company === 'aon' ? <div className="footerSocials footerItem">
                    <a className="iconfab-facebook" href='https://www.facebook.com/Aonplc/'></a>
                    <a className="iconfab-linkedin" href='https://www.linkedin.com/company/aon/'></a>
                    <a className="iconfab-twitter" href='https://twitter.com/aon_plc'></a>
                </div> : <div className="footerSocials footerItem">
                    <a className="iconfab-facebook"
                        href='https://www.facebook.com/ERN-Evaluaci%C3%B3n-de-Riesgos-Naturales-113488322134682/'
                    ></a>
                    <a
                        className="iconfab-linkedin"
                        href='https://www.linkedin.com/company/ern-evaluaci-n-de-riegos-naturales/'
                    ></a>
                    <a className="iconfab-twitter" href='https://twitter.com/ERN_Riesgos'></a>
                    <a className="iconfab-instagram" href='https://www.instagram.com/ern_mex/'></a>
                </div>}
            </div>
        </div>
    );
}

export default Footer;
